module.exports = __webpack_public_path__ + "static/media/img_payment_failed.f597c01d.png";